module.exports = __webpack_public_path__ + "static/media/hya-minus.90582225.svg";